import React from "react";

import { Button } from "~/components/button";
import { useGridLayoutContext } from "~/components/grid-layout/use-grid-layout-context";
import { IconEnlarge } from "~/components/icon";
import { ZIndexBoundary } from "~/components/z-index-boundary";
import { cx } from "~/tools/class-variance";

import { CtxMenuItem } from "../react/CtxMenu/CtxMenuItem";
import { CtxPopoverMenu } from "../react/CtxMenu/CtxPopoverMenu";
import { Tooltip } from "../react/tooltip/Tooltip";

export interface DashboardWidgetActionsProps {
	onDelete?: VoidFunction;
	onEdit?: VoidFunction;
	onEnlarge?: VoidFunction;
}

export const DashboardWidgetActions: React.FC<DashboardWidgetActionsProps> = ({
	onEnlarge,
	onDelete,
	onEdit,
}: DashboardWidgetActionsProps) => {
	const gridLayoutContext = useGridLayoutContext();

	if (!(onDelete || onEdit || onEnlarge)) {
		return null;
	}

	return (
		<div className="flex w-full flex-row gap-4 text-gray-800">
			{onEnlarge && (
				<Tooltip title="Open in metric inspector">
					<Button className={gridLayoutContext?.dragCancelClassName} icon onClick={() => onEnlarge()} size="xs">
						<IconEnlarge />
					</Button>
				</Tooltip>
			)}

			{(onDelete ?? onEdit) && (
				<ZIndexBoundary zIndex={(closestZIndex = 0) => closestZIndex + 50}>
					{(zIndex) => (
						<div className={cx("cursor-[initial]", gridLayoutContext?.dragCancelClassName)}>
							<CtxPopoverMenu ellipsisClassName="m-0" zIndex={zIndex}>
								{onEdit && (
									<CtxMenuItem
										label="Edit widget"
										onClick={() => {
											onEdit();
										}}
									/>
								)}

								{onDelete && (
									<CtxMenuItem
										label="Delete widget"
										onClick={() => {
											onDelete();
										}}
									/>
								)}
							</CtxPopoverMenu>
						</div>
					)}
				</ZIndexBoundary>
			)}
		</div>
	);
};
